/**
 * Created by aleco on 9/26/2017.
 * Continued by PJ on 04/15/2026
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { CsvMappingFields } from "../../entities/csvMappingFields";
import { Indicator, IndicatorDataset } from "../../entities/indicator";
import { IndicatorService } from "../../services/indicator.service";
import { ServiceService } from "../../services/service.service";
import { ReportService } from "../../services/report.service";
import { RiskService } from "../../services/riskService";
import { Service } from "../../entities/service";
import { PagerDataObject } from "../../entities/pagerDataObject";
import { Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrService } from "ngx-toastr";
import { TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver';

@Component({
    selector: '<ntr-indicator-add-edit>',
    templateUrl: './indicator-add-edit.component.html',
    styleUrls: ['./indicator-add-edit.component.css'],
    standalone: false
})
export class IndicatorAddEditComponent implements OnInit {

  indicator: Indicator = new Indicator();
  submitted = false;
  services: Service[];
  reports: any[] = [];

  fileFormats: any[][] = [[], []];
  mappingObjects: any[][] = [[], []];
  compareFields: any[][] = [[], []];
  dateFields: any[][] = [[], []];
  reportColumns: any[][] = [[], []];
  reportCompareFields: any[][] = [[], []];

  operations = [{ name: 'Descrepancy', type: '-' }, { name: 'Ratio', type: '/' }];
  sectors: Array<{ name: string, label: string }>;

  metaInfo: string[];
  columns: Array<any>;
  data: PagerDataObject;
  subscription: any;
  private dataSub$ = new Subject<any>();
  query: String;
  user;

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.sectors = this.riskService.getSectors();
    this.auth.getCurrentUser().subscribe(user => {
      this.user = user;
      this.reportService.getReportList().subscribe(reports => {
        this.reports = reports || [];
      });
      this.serviceService.getTotalServiceList("").subscribe(services => {
        this.services = services;
        this.route.paramMap.pipe(
            switchMap((params: ParamMap) => this.indicatorService.getIndicator(params.get('id'))))
            .subscribe(indicator => {
              if (indicator !== null) {
                this.indicator = indicator;

                if (!this.indicator.datasets || this.indicator.datasets.length < 2) {
                  this.indicator.datasets = [new IndicatorDataset(), new IndicatorDataset()];
                }

                this.fileFormats = this.indicator.datasets.map(() => []);
                this.mappingObjects = this.indicator.datasets.map(() => []);
                this.compareFields = this.indicator.datasets.map(() => []);
                this.dateFields = this.indicator.datasets.map(() => []);
                this.reportColumns = this.indicator.datasets.map(() => []);
                this.reportCompareFields = this.indicator.datasets.map(() => []);

                this.indicator.datasets.forEach((ds, i) => {
                  if (ds.sourceType === 'report') {
                    if (!ds.reportId && this.reports?.length === 1) {
                      ds.reportId = this.reports[0].id;
                    }
                    if (ds.reportId) this.onChangeReport(ds.reportId, i);
                  } else {
                    if (ds.service) this.onChangeService(ds.service, i);
                    if (ds.fileFormat) this.onChangeFileFormat(ds.fileFormat, i);
                  }
                });

                this.columns = this.indicatorService.getColumnsIndicatorRun(this.indicator.datasets);
                this.metaInfo = this.indicatorService.getMetaIndicatorRunInfo(this.indicator.datasets);

                if (this.query) {
                  this.dataSub$.next(this.query + "&indicator_id=" + this.indicator.id);
                }
              }
            });
      });
    });
  }

  constructor(private serviceService: ServiceService,
              public indicatorService: IndicatorService,
              private reportService: ReportService,
              private riskService: RiskService,
              private auth: AuthService,
              private router: Router,
              private route: ActivatedRoute,
              private alertService: ToastrService,
              private translate: TranslateService) {
    this.subscription = this.dataSub$.pipe(
        switchMap(filter => this.indicatorService.getIndicatorResult(filter))
    ).subscribe(data => {
      this.data = data;
    });
    this.metaInfo = this.indicatorService.getMetaIndicatorRunInfo();
    this.columns = this.indicatorService.getColumnsIndicatorRun();
  }

  onCompareChange(event: any, index: number) {
    this.indicator.datasets[index].compare = event;
  }

  onSubmit() {
    this.submitted = true;
    this.indicatorService.add(this.indicator).subscribe(indicator => {
      this.goToList();
    });
  }

  onChangeService(value, index: number) {
    const service = this.services.find(item => item.id === value);
    if (service) {
      while (this.fileFormats.length <= index) this.fileFormats.push([]);
      this.fileFormats[index] = service.fileFormats;
    }
  }

  onChangeFileFormat(value, index: number) {
    const formats = this.fileFormats[index] || [];
    const format = formats.find(item => item.name === value);
    if (format) {
      while (this.mappingObjects.length <= index) this.mappingObjects.push([]);
      while (this.compareFields.length <= index) this.compareFields.push([]);
      while (this.dateFields.length <= index) this.dateFields.push([]);

      this.mappingObjects[index] = format.mappingObjects;
      this.compareFields[index] = format.mappingObjects
          .filter(item => CsvMappingFields.isAmountColumn(item))
          .map(({ name }) => name);
      this.dateFields[index] = format.mappingObjects
          .filter(item => CsvMappingFields.isDateColumn(item));
    }
  }

  get hasServiceDatasets(): boolean {
    return this.indicator.datasets.some(ds => ds.sourceType !== 'report');
  }

  get hasReportDatasets(): boolean {
    return this.indicator.datasets.some(ds => ds.sourceType === 'report');
  }

  onSourceTypeChange(index: number) {
    const ds = this.indicator.datasets[index];
    ds.match = null;
    ds.compare = [];
    ds.date = null;
    if (ds.sourceType === 'report' && this.reports?.length === 1) {
      ds.reportId = this.reports[0].id;
      this.onChangeReport(ds.reportId, index);
    }
  }

  onChangeReport(value: any, index: number) {
    this.indicator.datasets[index].reportId = value;
    this.reportService.getReport(value).subscribe(report => {
      while (this.reportColumns.length <= index) this.reportColumns.push([]);
      while (this.reportCompareFields.length <= index) this.reportCompareFields.push([]);
      this.reportColumns[index] = report.columns || [];
      this.reportCompareFields[index] = (report.columns || []).filter(c => c.summable);
    });
  }

  addDataset() {
    this.indicator.datasets.push(new IndicatorDataset());
    this.fileFormats.push([]);
    this.mappingObjects.push([]);
    this.compareFields.push([]);
    this.dateFields.push([]);
    this.reportColumns.push([]);
    this.reportCompareFields.push([]);
  }

  removeDataset(index: number) {
    if (this.indicator.datasets.length > 2) {
      this.indicator.datasets.splice(index, 1);
      this.fileFormats.splice(index, 1);
      this.mappingObjects.splice(index, 1);
      this.compareFields.splice(index, 1);
      this.dateFields.splice(index, 1);
      this.reportColumns.splice(index, 1);
      this.reportCompareFields.splice(index, 1);
    }
  }

  goToList() {
    this.router.navigateByUrl('/indicator');
  }

  isCollapsed = false;

  running = false;

  runIndicator() {
    this.running = true;
    this.indicatorService.add(this.indicator).pipe(
      switchMap(saved => {
        this.indicator.id = saved.id;
        return this.indicatorService.runIndicator(this.indicator);
      })
    ).subscribe((result: any) => {
      if (result && result.lastRun) {
        this.indicator.lastRun = result.lastRun;
      } else {
        this.indicator.lastRun = new Date();
      }
      this.isCollapsed = true;
      this.columns = this.indicatorService.getColumnsIndicatorRun(this.indicator.datasets);
      this.metaInfo = this.indicatorService.getMetaIndicatorRunInfo(this.indicator.datasets);
      this.dataSub$.next(this.query + "&indicator_id=" + this.indicator.id);
      this.running = false;
      this.alertService.success(this.translate.instant('INDICATOR.RUN_SUCCESS', { name: this.indicator.name }));
    }, () => {
      this.running = false;
    });
  }

  onGridQuery(query) {
    this.query = query;
    if (!this.indicator?.id) return;
    this.dataSub$.next(query + "&indicator_id=" + this.indicator.id);
  }

  onCheckboxChange(event) {
    this.indicator.riskManagement = !!event.target.checked;
  }

  exporting = false;

  export$() {
    this.exporting = true;
    this.indicatorService.export$(this.query + "&indicator_id=" + this.indicator.id).subscribe(data => {
      const file = new Blob([data], {});
      const filename = 'document-' + this.indicator.name + '-' + Date.now() + '.xlsx';
      saveAs(file, filename);
      this.alertService.success(this.translate.instant('REPORT.EXPORT_SUCCESS'));
      this.exporting = false;
    }, () => {
      this.exporting = false;
    });
  }

  onDateFromChange() {
    if (this.indicator.filterDateFrom) {
      // if From > To, reset To
      if (this.indicator.filterDateTo &&
          this.indicator.filterDateFrom > this.indicator.filterDateTo) {
        this.indicator.filterDateTo = this.indicator.filterDateFrom;
      }
      this.indicator.year = new Date(this.indicator.filterDateFrom).getFullYear() + '';
    }
  }

  onDateToChange() {
    if (this.indicator.filterDateTo) {
      // if To < From, reset From
      if (this.indicator.filterDateFrom &&
          this.indicator.filterDateTo < this.indicator.filterDateFrom) {
        this.indicator.filterDateFrom = this.indicator.filterDateTo;
      }
      this.indicator.year = new Date(this.indicator.filterDateTo).getFullYear() + '';
    }
  }

  toDateString(date: Date): string {
    if (!date) return '';
    return new Date(date).toISOString().split('T')[0];
  }

}